export const RESET_PARAMETERS = 'report/RESET_PARAMETERS';

export const SET_REPORT_TYPES = 'report/SET_REPORT_TYPES';
export const SET_PHASES = 'report/SET_PHASES';
export const SET_SECTIONS = 'report/SET_SECTIONS';
export const SET_PROCEDURES = 'report/SET_PROCEDURES';
export const SET_MONITORING_EVENTS = 'report/SET_MONITORING_EVENTS';
export const SET_REPORT_TYPE_ID = 'report/SET_REPORT_TYPE_ID';
export const SET_PROGRAM_ID = 'report/SET_PROGRAM_ID';
export const SET_PROJECT_ID = 'report/SET_PROJECT_ID';
export const SET_PHASE_ID = 'report/SET_PHASE_ID';
export const SET_MONITORING_EVENT_ID = 'report/SET_MONITORING_EVENT_ID';
export const SET_PROCEDURE_ID = 'report/SET_PROCEDURE_ID';
export const SET_SELECTED_SECTIONS = 'report/SET_SELECTED_SECTIONS';
export const NEXT_PAGE = 'report/NEXT_PAGE';
export const PREVIOUS_PAGE = 'report/PREVIOUS_PAGE';

export const SET_PROJECT = 'report/SET_PROJECT';
export const SET_CURRENT_EVENT = 'report/SET_CURRENT_EVENT';
export const SET_PREVIOUS_EVENT_ID = 'report/SET_PREVIOUS_EVENT_ID';
export const SET_PREVIOUS_EVENT = 'report/SET_PREVIOUS_EVENT';
export const SET_PHOTO_POINTS = 'report/SET_PHOTO_POINTS';
export const SET_HIDE_PHOTO_POINT = 'report/SET_HIDE_PHOTO_POINTS';
export const SET_PHOTOS_LOADED = 'report/SET_PHOTOS_LOADED';
export const UPDATE_PHOTO = 'report/UPDATE_PHOTO';
